// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";

interface HeaderProps {
  children: object;
}

const PageHeader: React.FunctionComponent<HeaderProps> = (
  props: HeaderProps
) => {
  const { children } = props;

  return (
    <>
      <div className="content-header">{children}</div>
    </>
  );
};

export default PageHeader;
